import PoiDelete from "./PoiDelete";

export default PoiDelete;
